import { transform } from 'lodash-es'
import { getStoreCountry } from './country'
import { parseNumber } from './helpers'
import { SCREEN_SIZES } from './screens'

export const DEV = import.meta.env.DEV
// TODO: Should we put this here or not? window.__DEV__ = DEV

export const CDN_URL = `https://${window.Shopify.cdnHost}/shop`

export const ASSET_URL = window.theme.stylesheet.split('/').slice(0, -1).join('/')

function getToken(): string {
	// These are (intentionally) publicly visible
	switch (getStoreCountry()) {
		case 'NO':
			return 'db035772af39a34c43cc70d0c7ffd8bd'
		case 'US':
			return '45fae9608173048c6ea7468f4e25a168'
		case 'EU':
			return '8e85aa52c68e5d2b38e916f9e982090b'
		case 'SE':
			return '7c1922d485362e0ceffa14a3c3491664'
	}
}

export const STOREFRONT_CONFIG = {
	domain: DEV ? `https://${window.Shopify.shop}` : location.origin,
	token: getToken()
}

const __PRODUCT_IDS =
	getStoreCountry() === 'NO'
		? ({
				Auk: 'gid://shopify/Product/4347673149517',
				ExtraNutrients: 'gid://shopify/Product/7676091498728',
				YearOfNutrients: 'gid://shopify/Product/7690783981814', // TODO: Replace?
				PartyPack: 'gid://shopify/Product/7676091171048',
				ChiliKit: 'gid://shopify/Product/7542740353256'
		  } as const)
		: getStoreCountry() === 'SE'
		? ({
				Auk: 'gid://shopify/Product/7994870006040',
				ExtraNutrients: 'gid://shopify/Product/7994870366488',
				YearOfNutrients: 'gid://shopify/Product/7690783981814',
				PartyPack: 'gid://shopify/Product/7994869907736',
				ChiliKit: 'gid://shopify/Product/7994869940504'
		  } as const)
		: getStoreCountry() === 'US'
		? ({
				Auk: 'gid://shopify/Product/8818462884143',
				ExtraNutrients: 'gid://shopify/Product/0000', // TODO
				YearOfNutrients: 'gid://shopify/Product/0000', // TODO
				PartyPack: 'gid://shopify/Product/8818467307823',
				ChiliKit: 'gid://shopify/Product/8818462818607'
		  } as const)
		: ({
				Auk: 'gid://shopify/Product/7535808151798',
				ExtraNutrients: 'gid://shopify/Product/7537534271734',
				YearOfNutrients: 'gid://shopify/Product/7690783981814',
				PartyPack: 'gid://shopify/Product/7535807987958',
				ChiliKit: 'gid://shopify/Product/7535808053494'
		  } as const)
export const PRODUCT_IDS: Readonly<Record<keyof typeof __PRODUCT_IDS, ProductID>> = __PRODUCT_IDS

type Screens = typeof SCREEN_SIZES
export type ScreenSize = keyof Screens
export type Breakpoints = Record<ScreenSize, number>
export const BREAKPOINTS = transform<Screens, Breakpoints>(
	SCREEN_SIZES,
	(res, value, key: ScreenSize) => (res[key] = Number.parseInt(value, 10))
)

/** Firebase region */
export const FUNCTIONS_REGION = getStoreCountry() === 'US' ? 'us-central1' : 'europe-west1'
/** Firebase project ID */
export const FB_PROJECT_ID = 'auk-api'

export const AUK_API_URL = DEV
	? `http://localhost:5001/${FB_PROJECT_ID}/${FUNCTIONS_REGION}`
	: `https://${FUNCTIONS_REGION}-${FB_PROJECT_ID}.cloudfunctions.net`

export function ENV() {
	const site = window.Shopify.shop.split('.').shift() as string
	switch (import.meta.env.NODE_ENV) {
		case 'production':
			switch (parseNumber(window.theme.id)) {
				case 153421676847: // auk-us Production theme
				case 129173586152: // aukstore Production theme
				case 130260992246: // aukeco Production theme
				case 137505145112: // auksweden Production theme
					return {
						type: 'production',
						site,
						sampleRate: 0.01
					} as const

				default:
					return {
						type: 'staging',
						site,
						sampleRate: 1
					} as const
			}

		case 'development':
		default:
			return {
				type: 'development',
				site,
				sampleRate: 1
			} as const
	}
}
